// extracted by mini-css-extract-plugin
module.exports = {"padded":"Button_padded__60f58","secondary":"Button_secondary__gf0Uw","primary":"Button_primary__frHpN"};